import React from "react";

import {
  LoginUser,
  getCurrentUserDetails,
  checkFirstUser,
  getUserGroupById,
} from "../service/endpoint-manager";

import {
  USER_PROFILE,
  REFRESH_TOKEN,
  ID_TOKEN,
  ACCESS_TOKEN,
  APP_FUNCTIONS,
  PPE_HISTORY,
  HAND_HYGIENE_HISTORY,
} from "../types/micellinous-constants";

export const AuthContext = React.createContext("");

class AuthProvider extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      isAuthenticated: false,
      loginSuccess: false,
      loginError: false,
      showLogin: false,
      account: {},
      userGroup: null,
      verified: true,
      errorMessage: null,
      errorAccessDenied: null,
      sessionHasBeenFetched: false,
      currentLocale: undefined,
      loginTokenVerify: false,
      currentUser: null,
      isFirstUser: false,
    };
  }

  componentDidMount = async () => {
    await this.getSession();
    this.setState({
      ...this.state,
      loading: false,
    });
  };
  setErrorAccessDenied = (errorObj) => {
    this.setState({
      ...this.state,
      errorAccessDenied: errorObj,
    });
  };

  componentWillMount() {
    const theme = localStorage.getItem("theme");
    if (theme === null || theme === undefined) {
      localStorage.setItem("theme", "light");
    }
  }

  setTheme = (param) => {
    this.setState({
      ...this.state,
    });
    localStorage.setItem("theme", param);
  };

  clearAuthToken = () => {
    localStorage.removeItem(HAND_HYGIENE_HISTORY);
    localStorage.removeItem(PPE_HISTORY);
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(ID_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(USER_PROFILE);
  };

  logout = () => {
    this.clearAuthToken();
    this.setState({
      ...this.state,
      loading: false,
      showLogin: true,
      isAuthenticated: false,
      userGroup: null,
      loginTokenVerify: false,
      errorAccessDenied: null,
    });
  };

  checkIfFirstUser = async () => {
    let usersExist = null;
    const result = await checkFirstUser();

    usersExist = result?.data?.status;
    return usersExist;
  };

  async getSession() {
    if (
      localStorage.getItem(ACCESS_TOKEN) ||
      localStorage.getItem(ID_TOKEN) ||
      localStorage.getItem(REFRESH_TOKEN)
    ) {
      const isAuthenticated = true;
      const verified = true;

      this.getCurrentUser();

      this.setState({
        ...this.state,
        isAuthenticated,
        sessionHasBeenFetched: true,
        verified,
        currentLocale: "en",
      });

      return true;
    }
  }
  async setSession(accessToken, idToken, refreshToken, userData) {
    localStorage.setItem(ACCESS_TOKEN, accessToken);
    localStorage.setItem(ID_TOKEN, idToken);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
    localStorage.setItem(USER_PROFILE, JSON.stringify(userData));

    const isAuthenticated = true;
    const verified = true;

    this.getCurrentUser();

    this.setState({
      ...this.state,
      isAuthenticated,
      sessionHasBeenFetched: true,

      verified,
      currentLocale: "en",
    });
    return true;
  }

  resetLoginError = () => {
    this.setState({
      ...this.state,
      loginError: false,
      errorMessage: null,
    });
  };

  setVerify = () => {
    this.setState({
      ...this.state,
      verified: true,
    });
  };

  login = async (username, password) => {
    try {
      const result = await LoginUser(username, password);

      if (result?.status === 200) {
        const accessToken = result?.data?.body?.access;
        const idToken = result?.data?.body?.idToken;
        const refreshToken = result?.data?.body?.refresh;
        const userData = result?.data?.body?.userData;

        if (accessToken && idToken && refreshToken) {
          this.setSession(accessToken, idToken, refreshToken, userData);
        }
      } else {
        this.setState({
          ...this.state,
          loginError: true,
          errorMessage: "Something went wrong",
          showLogin: false,
          loginSuccess: false,
          loading: false,
        });
        return result;
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loginError: true,
        errorMessage: error,
        showLogin: false,
        loginSuccess: false,
        loading: false,
      });
      return error;
    }
  };

  // Function to fetch and set the user group based on userGroup ID
  getUserGroup = async (userGroupId) => {
    if (userGroupId) {
      return await getUserGroupById(userGroupId);
    }
  };

  getCurrentUser = async () => {
    const userDetails = localStorage.getItem("user-profile");
    var json = JSON.parse(userDetails);
    const user = await getCurrentUserDetails(json.user_id);
    const userGroup = await this.getUserGroup(json.userGroup);

    this.setState({
      ...this.state,
      account: user,
      userGroup: userGroup.data.body,
    });
  };

  getAppFunctions = async () => {
    return APP_FUNCTIONS;
  };
  render() {
    return (
      <AuthContext.Provider
        value={{
          loading: this.state.loading,
          isAuthenticated: this.state.isAuthenticated,
          errorAccessDenied: this.state.errorAccessDenied,
          setErrorAccessDenied: this.setErrorAccessDenied,
          loginSuccess: this.state.loginSuccess,
          loginError: this.state.loginError,
          showLogin: this.state.showLogin,
          account: this.state.account,
          userGroup: this.state.userGroup,
          verified: this.state.verified,
          errorMessage: this.state.errorMessage,
          sessionHasBeenFetched: this.state.sessionHasBeenFetched,
          currentLocaled: this.state.currentLocale,
          loginTokenVerify: this.state.loginTokenVerify,
          login: this.login,
          verifyLoginToken: this.verifyLoginToken,
          logout: this.logout,
          setLocale: this.setLocale,
          setTheme: this.setTheme,

          resetLoginError: this.resetLoginError,
          setVerify: this.setVerify,

          isFirstUser: this.state.isFirstUser,
          checkIfFirstUser: this.checkIfFirstUser,
          getSession: this.getSession,
        }}
      >
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

export default AuthProvider;
